import { isEmpty } from "lodash";

type Feature = string;
type FilterName = string;
export type FilterValue = (string | number)[];
export type FeatureFilters = Record<FilterName, FilterValue>;

export type FiltersByFeature = Record<Feature, FeatureFilters>;

export const trimFilterValue = (filterValue: FilterValue) => {
  if (Array.isArray(filterValue) && filterValue.length > 0) {
    return [...filterValue].sort((a, b) => {
      return a.toString().localeCompare(b.toString());
    });
  }
  return undefined;
};

export const trimFeatureFilters = (featureFilters: FeatureFilters) => {
  if (isEmpty(featureFilters)) {
    return undefined;
  }
  const res = Object.fromEntries(
    Object.entries(featureFilters)
      .map(([filterName, filterValue]) => [
        filterName,
        trimFilterValue(filterValue),
      ])
      .filter(([, trimmedFilter]) => {
        return !isEmpty(trimmedFilter);
      })
  );
  return isEmpty(res) ? undefined : res;
};

export const trimFiltersByFeatures = (filtersByFeatures: FiltersByFeature) => {
  if (isEmpty(filtersByFeatures)) {
    return undefined;
  }
  const res = Object.fromEntries(
    Object.entries(filtersByFeatures)
      .map(([featureName, featureFilters]) => [
        featureName,
        trimFeatureFilters(featureFilters),
      ])
      .filter(([, trimmedFilter]) => {
        return !isEmpty(trimmedFilter);
      })
  );
  return isEmpty(res) ? undefined : res;
};
